module.exports = __webpack_public_path__ + "img/3-4.1665d6c9.svg";